import React, { Component } from 'react';
import { Switch, Route , Link} from 'react-router-dom'
import Currency from './currency/Currency';
import Search from '../search/search';

class Header extends Component {

    shouldComponentUpdate() {
       return false;
    }
    render() {
        return (

            <header>
               <section className="head_main fx" id="head-mini">
                  <div className="container">
                     <div id="xf" className="row hidden-xs stk pad-15">
                        <div className="col-md-8 col-sm-6">
                           <div className="col-md-4">
                              <Link to="/">
                                 <img src="https://mordorintelligence.com:81/mordorlabs/img/home_image/logo.png" alt="mordor logo" id="logi" />
                              </Link>
                           </div>

                           <Search />

                        </div>
                        <div className="col-md-4 col-sm-6 text-right ">
                           <div className="pull-right conct-no">
                              +1 617-765-2493
                           </div>
                           <div className="pull-right social-ico">
                              <a target="_blank" href="https://www.linkedin.com/company/mordor-intelligence"><i className="fa fa-linkedin social-icons"></i></a>
                              <a target="_blank" href="mailto:info@mordorintelligence.com"><i className="fa fa-envelope-o social-icons"></i></a>
                              <a target="_blank" href="https://twitter.com/mordorintel"><i className="fa fa-twitter social-icons"></i></a>
                              <a target="_blank" href="https://plus.google.com/+Mordorintelligence/posts"><i className="fa fa-google-plus social-icons"></i></a>
                           </div>
                        </div>
                     </div>
                     <div className="row">
                        <div className="container-fluid pad-0">
                           <nav className="navbar navbar-default">
                              <div className="navbar-header">
                                 <button type="button" className="navbar-toggle" data-toggle="collapse" data-target="#myNavbar">
                                    <span className="icon-bar"></span>
                                    <span className="icon-bar"></span>
                                    <span className="icon-bar"></span>
                                 </button>
                                 <Link className="navbar-brand hidden-sm hidden-md hidden-lg" to="/"><img src="https://mordorintelligence.com:81/mordorlabs/img/home_image/mordor_logo.png" className="img-responsive small-logo" alt="mordor logo" /></Link>
                              </div>
                              <div className="collapse navbar-collapse nav_bg navi" id="myNavbar">
                                 <ul className="nav navbar-nav nana" >
                                    <li className="sr-only"><Link to="/"><img src="https://mordorintelligence.com:81/mordorlabs/img/home_image/logo.png" alt="mordor logo" /></Link></li>
                                    <li className="active"><Link  to='/'>Home</Link></li>
                                    <li><Link to='/industry-reports'>Industry reports</Link></li>
                                    <li className="dropdown">
                                       <Link to="/consulting" className="dropdown-toggle" data-toggle="dropdown" >Consulting <b className="caret"></b></Link>
                                       <ul className="dropdown-menu dm">
                                          <li><Link to="/consulting">Our Methodology</Link></li>
                                          <li><Link to="/custom-research">Custom Research</Link></li>
                                          <li><Link to="/flash-delivery">Flash Delivery</Link></li>
                                          <li><Link to="/growth-partnership">Growth Partnership</Link></li>
                                       </ul>
                                    </li>
                                    <li><a target="_blank" href="https://blog.mordorintelligence.com/">Blog</a></li>
                                    <li><Link to="/press-release">Press releases</Link></li>
                                    <li><Link to="/contact-us">Contact</Link></li>
                                    <li className="pull-right">
                                      <Currency/>
                                    </li>
                                 </ul>
                              </div>
                           </nav>
                        </div>
                     </div>
                  </div>
               </section>
            </header>

        )


    }
}

export default Header;



// WEBPACK FOOTER //
// ./src/header/Header.js